import {
  type SidebarDefinition,
  type SidebarSnapshot,
  defineSidebar,
  readSidebar,
} from "@/types/sidebar-session";

export enum FollowUpSidebarCommand {
  CONSUME_REQUESTED_DAY = "CONSUME_REQUESTED_DAY",
}
interface FollowUpSidebarPayload {
  requestedDay: Date | null;
}
type FollowUpSidebarInput =
  | { requestedDay?: Date | null }
  | FollowUpSidebarCommand;

export const followUpSidebarDefinition: SidebarDefinition<
  FollowUpSidebarInput,
  FollowUpSidebarPayload
> = defineSidebar<FollowUpSidebarInput, FollowUpSidebarPayload>({
  id: "FOLLOW_UP",
  label: "Follow-Up",
  order: 20,
  group: "CLINICAL",
  isAvailable: (environment) => environment.capabilities.FOLLOW_UP !== false,
  strategy: {
    planOpen(context, input) {
      const current = context.read(followUpSidebarDefinition);
      if (input === FollowUpSidebarCommand.CONSUME_REQUESTED_DAY) {
        if (!current) return {};
        return {
          upsert: [
            context.write(followUpSidebarDefinition, { requestedDay: null }),
          ],
        };
      }
      return {
        upsert: [
          context.write(followUpSidebarDefinition, {
            requestedDay:
              input.requestedDay === undefined
                ? (current?.payload.requestedDay ?? null)
                : input.requestedDay,
          }),
        ],
        select: followUpSidebarDefinition.id,
      };
    },
  },
});

const WAITLIST_PAYLOAD = {};
export const waitlistSidebarDefinition: SidebarDefinition<
  void,
  Record<string, never>
> = defineSidebar<void, Record<string, never>>({
  id: "WAITLIST",
  label: "Waitlist",
  order: 20,
  group: "CLINICAL",
  isAvailable: (environment) => environment.capabilities.WAITLIST !== false,
  strategy: {
    planOpen(context) {
      return {
        upsert: [context.write(waitlistSidebarDefinition, WAITLIST_PAYLOAD)],
        select: waitlistSidebarDefinition.id,
      };
    },
  },
});

export function selectFollowUpSidebar(state: Pick<SidebarSnapshot, "entries">) {
  return readSidebar(state, followUpSidebarDefinition)?.payload ?? null;
}
export function selectWaitlistSidebar(state: Pick<SidebarSnapshot, "entries">) {
  return readSidebar(state, waitlistSidebarDefinition)?.payload ?? null;
}
